/**
 * Webová aplikace na ploše iOS nainstalovaná ještě s průhledným stavovým
 * řádkem (`apple-mobile-web-app-status-bar-style: black-translucent`).
 *
 * iOS styl stavového řádku čte jen při přidání na plochu, takže starší
 * instalace ho drží dál: stránka se kreslí pod stavový řádek (horní safe
 * area > 0) a dole jí chybí pruh výšky stavového řádku (WebKit bug 301108).
 * Takovou instalaci označíme třídou na <html>, ať CSS ošetří jen ji —
 * nové instalace (`default`) sahají až ke spodní hraně.
 *
 * `navigator.standalone` existuje jen na iOS, Android ani prohlížeč třídu
 * nedostanou.
 */
export const TRIDA_PRUHLEDNY_STATUS_BAR = 'ios-pruhledny-status-bar';

export function oznacIosInstalaci() {
    if (window.navigator.standalone !== true) return;

    const zmer = () => {
        const sonda = document.createElement('div');
        sonda.style.cssText = 'position:fixed;top:0;left:0;width:1px;visibility:hidden;pointer-events:none;'
            + 'height:env(safe-area-inset-top,0px)';
        document.body.appendChild(sonda);
        const pruhledny = sonda.getBoundingClientRect().height > 0;
        sonda.remove();
        document.documentElement.classList.toggle(TRIDA_PRUHLEDNY_STATUS_BAR, pruhledny);
    };

    zmer();
    // WKWebView občas dosadí safe area až chvíli po načtení; při otočení se mění
    setTimeout(zmer, 600);
    window.addEventListener('resize', zmer);
}
